module.exports = __webpack_public_path__ + "static/media/moon-stars.5053b026.svg";